import { createClient } from '@supabase/supabase-js';

// Publishable (client-safe) credentials — access is governed by Row Level Security in Supabase.
const SUPABASE_URL = 'https://gwfminvzqlagneuwsrxp.supabase.co';
const SUPABASE_PUBLISHABLE_KEY = 'sb_publishable_oD7eX-Sg-sKU54tRCrewTw_DQ340-aS';

export const supabase = createClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);
